import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Home from "./components/home/Home";
import Patrocinio from "./components/patrocinio/Patrocinio";
import Viaje from "./components/viaje/Viaje";
import Tarifas from "./components/tarifas/Tarifas";
import Organizadores from './components/organizadores/Organizadores'
import Programa from "./components/programa/Programa";
function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />}></Route>
          <Route path="/patrocinio" element={<Patrocinio />}></Route>
          <Route path="/hoteles-y-transporte" element={<Viaje />}></Route>
          <Route path="/tarifas" element={<Tarifas />}></Route>
          <Route path="/organizadores" element={<Organizadores />}></Route>
          <Route path="/programa" element={<Programa />}></Route>

        </Route>
      </Routes>
    </Router>
  );
}

export default App;
